import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var ShortenPipe = (function () {
    function ShortenPipe() {
    }
    ShortenPipe.prototype.transform = function (text, length, suffix, wordBreak) {
        if (length === void 0) { length = 0; }
        if (suffix === void 0) { suffix = ''; }
        if (wordBreak === void 0) { wordBreak = true; }
        if (!isString(text)) {
            return text;
        }
        if (text.length > length) {
            if (wordBreak) {
                return text.slice(0, length) + suffix;
            }
            if (!!~text.indexOf(' ', length)) {
                return text.slice(0, text.indexOf(' ', length)) + suffix;
            }
        }
        return text;
    };
    return ShortenPipe;
}());
export { ShortenPipe };
ShortenPipe.decorators = [
    { type: Pipe, args: [{ name: 'shorten' },] },
];
/** @nocollapse */
ShortenPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=shorten.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/shorten.js
// module id = 266
// module chunks = 4